/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppointmentsAliases {
  AUTOCOMPLETE_EXAME_TYPE = 'autocomplete-exame-type',
  AUTOCOMPLETE_EXAME_TYPE_RESULT = 'autocomplete-exame-type-result',
  AUTOCOMPLETE_FIELD_PHYSICIAN = 'autocomplete-field-physician',
  AUTOCOMPLETE_FIELD_PHYSICIAN_RESULT = 'autocomplete-field-physician-result',
  AUTOCOMPLETE_LOCATION = 'autocomplete-location',
  AUTOCOMPLETE_LOCATION_RESULT = 'autocomplete-location-result',
  AUTOCOMPLETE_MEDICAL_AREA = 'autocomplete-medical-area',
  AUTOCOMPLETE_MEDICAL_AREA_RESULT = 'autocomplete-medical-area-result',
  AUTOCOMPLETE_SPECIALITY = 'autocomplete-speciality',
  AUTOCOMPLETE_SPECIALITY_RESULT = 'autocomplete-speciality-result',
  AUTOCOMPLETE_STEP_1 = 'autocomplete-step-1',
  AUTOCOMPLETE_STEP_1_RESULT = 'autocomplete-step-1-result',
  BREADCRUMB_0 = 'breadcrumb-0',
  CARD_AVATAR_WITH_TWO_SUBTITLES_0 = 'card-avatar-with-two-subtitles-0',
  CARD_AVATAR_WITH_TWO_SUBTITLES_0_RESULT = 'card-avatar-with-two-subtitles-0-result',
  CHECKBOX_0 = 'checkbox-0',
  DATE_FIELD_RESULT = 'date-field-result',
  DATE_PICKER_APPOINTMENT_RANGE = 'date-picker-appointment-range',
  DECK_BLOCKED_ITEMS = 'deck-blocked-items',
  DECK_CHOOSEN_ITEMS = 'deck-choosen-items',
  DYNAMIC_FIELDS_QUIZ = 'dynamic-fields-quiz',
  DYNAMIC_FIELDS_QUIZ_RESULT = 'dynamic-fields-quiz-result',
  EXAM_AVATAR = 'exam-avatar',
  EXAM_AVATAR_RESULT = 'exam-avatar-result',
  EXAMS_FETCH = 'exams-fetch',
  EXAMS_FETCH_RESULT = 'exams-fetch-result',
  FETCH_ADDITIONAL_INFORMATION = 'fetch-additional-information',
  FETCH_FIELD_PHYSICIAN = 'fetch-field-physician',
  FETCH_FIELD_PHYSICIAN_RESULT = 'fetch-field-physician-result',
  FETCH_MEDICAL_AREA = 'fetch-medical-area',
  FETCH_MEDICAL_AREA_RESULT = 'fetch-medical-area-result',
  FETCH_SCHEDULE_TYPE = 'fetch-schedule-type',
  FETCH_SCHEDULE_TYPE_RESULT = 'fetch-schedule-type-result',
  FETCH_SPECILITY = 'fetch-specility',
  FETCH_SPECILITY_RESULT = 'fetch-specility-result',
  FETCH_STEP_1 = 'fetch-step-1',
  FIELD_CHECKBOX_SAVE = 'field-checkbox-save',
  FIELD_DATEFIELD_RESULT = 'field-datefield-result',
  FIELD_EXAM = 'field-exam',
  FIELD_EXAM_RESULT = 'field-exam-result',
  FIELD_EXAMS_TO_SCHEDULE = 'field-exams-to-schedule',
  FIELD_EXAMS_TO_SCHEDULE_RESULT = 'field-exams-to-schedule-result',
  FIELD_HEALTH = 'field-health',
  FIELD_HEALTH_RESULT = 'field-health-result',
  FIELD_LIST_EXAMS_TO_SCHEDULE = 'field-list-exams-to-schedule',
  FIELD_LIST_EXAMS_TO_SCHEDULE_RESULT = 'field-list-exams-to-schedule-result',
  FIELD_LIST_SCHEDULING = 'field-list-scheduling',
  FIELD_LIST_SCHEDULING_RESULT = 'field-list-scheduling-result',
  FIELD_MEDICAL_AREA = 'field-medical-area',
  FIELD_MEDICAL_AREA_RESULT = 'field-medical-area-result',
  FIELD_PHYSICIAN = 'field-physician',
  FIELD_PHYSICIAN_RESULT = 'field-physician-result',
  FIELD_SCHEDULING_LIST = 'field-scheduling-list',
  FIELD_SCHEDULING_LIST_RESULT = 'field-scheduling-list-result',
  FIELD_SPECIALITY = 'field-speciality',
  FIELD_SPECIALITY_RESULT = 'field-speciality-result',
  FIELD_STEP_1 = 'field-step-1',
  FIELD_STEP_1_RESULT = 'field-step-1-result',
  FILED_SCHEDULE_TYPE = 'filed-schedule-type',
  FILED_SCHEDULE_TYPE_RESULT = 'filed-schedule-type-result',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_ADDITIONAL_INFORMATION_RESULT = 'form-additional-information-result',
  FORM_DATEFIELD_RESULT = 'form-datefield-result',
  FORM_EXAMS_TO_SCHEDULE = 'form-exams-to-schedule',
  FORM_EXAMS_TO_SCHEDULE_RESULT = 'form-exams-to-schedule-result',
  FORM_INSURANCE = 'form-insurance',
  FORM_INSURANCE_RESULT = 'form-insurance-result',
  FORM_PATIENT = 'form-patient',
  FORM_PATIENT_RESULT = 'form-patient-result',
  FORM_QUIZ = 'form-quiz',
  FORM_QUIZ_RESULT = 'form-quiz-result',
  FORM_SCHEDULE_TYPE = 'form-schedule-type',
  FORM_SCHEDULE_TYPE_RESULT = 'form-schedule-type-result',
  FORM_STEP_3 = 'form-step-3',
  FORM_STEP_3_RESULT = 'form-step-3-result',
  HEALTH_INSURANCE_CARD2 = 'health-insurance-card2',
  HEALTH_INSURANCE_CARD2_RESULT = 'health-insurance-card2-result',
  HEIGHT_FIELD = 'height-field',
  HEIGHT_FIELD_RESULT = 'height-field-result',
  HEIGHT_INPUT = 'height-input',
  IMAGE_EXAM_TYPE = 'image-exam-type',
  IMAGE_EXAM_TYPE_RESULT = 'image-exam-type-result',
  LAYOUT_APPOINTMENTS = 'layout-appointments',
  LAYOUT_SEGMENT = 'layout-segment',
  LAYOUT_SEGMENT_RESULT = 'layout-segment-result',
  LAYOUT_STEP_DATE = 'layout-step-date',
  LAYOUT_STEP_SUGGESTION = 'layout-step-suggestion',
  LINK_CALL_WAITING_LIST = 'link-call-waiting-list',
  LOADER_ELIGIBILITY = 'loader-eligibility',
  LOADER_FINAL = 'loader-final',
  LOADER_SCHEDULE_TYPE = 'loader-schedule-type',
  MAPPER_AVATAR = 'mapper-avatar',
  MAPPER_AVATAR_RESULT = 'mapper-avatar-result',
  MAPPER_CHOOSEN_ITEM = 'mapper-choosen-item',
  MAPPER_EXAM_AVATAR = 'mapper-exam-avatar',
  MAPPER_EXAM_AVATAR_RESULT = 'mapper-exam-avatar-result',
  MAPPER_FIELD_PHYSICIAN = 'mapper-field-physician',
  MAPPER_FIELD_PHYSICIAN_RESULT = 'mapper-field-physician-result',
  MAPPER_IMAGE = 'mapper-image',
  MAPPER_IMAGE_RESULT = 'mapper-image-result',
  MAPPER_MEDICAL_AREA = 'mapper-medical-area',
  MAPPER_MEDICAL_AREA_RESULT = 'mapper-medical-area-result',
  MAPPER_SPECILITY = 'mapper-specility',
  MAPPER_SPECILITY_RESULT = 'mapper-specility-result',
  MAPPER_TEXT = 'mapper-text',
  MAPPER_TEXT_RESULT = 'mapper-text-result',
  PANEL_0_RESULT = 'panel-0-result',
  PANEL_1 = 'panel-1',
  PANEL_1_RESULT = 'panel-1-result',
  PANEL_3_RESULT = 'panel-3-result',
  PANEL_BLOCKED_ITEMS = 'panel-blocked-items',
  PANEL_DECK = 'panel-deck',
  PANEL_EXAM = 'panel-exam',
  PANEL_INFO = 'panel-info',
  PANEL_INFO_RESULT = 'panel-info-result',
  PANEL_INSURANCE = 'panel-insurance',
  PANEL_INSURANCE_RESULT = 'panel-insurance-result',
  PANEL_LOADER = 'panel-loader',
  PANEL_LOADER_ELIGIBILITY = 'panel-loader-eligibility',
  PANEL_LOADER_SCHEDULE_TYPE = 'panel-loader-schedule-type',
  PANEL_NOTIFICATION_STEP_DATE = 'panel-notification-step-date',
  PANEL_NOTIFICATION_STEP_SUGGESTION = 'panel-notification-step-suggestion',
  PANEL_QUIZ = 'panel-quiz',
  PANEL_QUIZ_RESULT = 'panel-quiz-result',
  PANEL_SCHEDULE_TYPE = 'panel-schedule-type',
  PANEL_SCHEDULE_TYPE_RESULT = 'panel-schedule-type-result',
  PANEL_STEP_1 = 'panel-step-1',
  PANEL_STEP_1_RESULT = 'panel-step-1-result',
  PANEL_STEP_3 = 'panel-step-3',
  PANEL_STEP_3_RESULT = 'panel-step-3-result',
  PANEL_TOTAL = 'panel-total',
  PATIENT_AVATAR = 'patient-avatar',
  PATIENT_AVATAR_RESULT = 'patient-avatar-result',
  SEGMENTED_CONTROL_0 = 'segmented-control-0',
  SEGMENTED_CONTROL_0_RESULT = 'segmented-control-0-result',
  SEGMENTED_CONTROL_SCHEDULE_TYPE = 'segmented-control-schedule-type',
  SEGMENTED_CONTROL_SCHEDULE_TYPE_RESULT = 'segmented-control-schedule-type-result',
  STEP_2_FETCH = 'step-2-fetch',
  STEP_2_FETCH_RESULT = 'step-2-fetch-result',
  STEP_2_FIELD = 'step-2-field',
  STEP_2_FIELD_RESULT = 'step-2-field-result',
  STEP_2_FORM = 'step-2-form',
  STEP_2_FORM_RESULT = 'step-2-form-result',
  STEP_2_MAPPER = 'step-2-mapper',
  STEP_2_MAPPER_RESULT = 'step-2-mapper-result',
  STEP_2_PANEL = 'step-2-panel',
  STEP_2_PANEL_RESULT = 'step-2-panel-result',
  STEP_2_TEXT = 'step-2-text',
  STEP_2_TEXT_RESULT = 'step-2-text-result',
  SUGGESTION_CARD_ITEM_0 = 'suggestion-card-item-0',
  SUGGESTION_CARD_ITEM_1 = 'suggestion-card-item-1',
  TEXT_EXAM_TYPE = 'text-exam-type',
  TEXT_EXAM_TYPE_RESULT = 'text-exam-type-result',
  TEXT_HEIGHT = 'text-height',
  TEXT_MEDICAL_AREA = 'text-medical-area',
  TEXT_MEDICAL_AREA_RESULT = 'text-medical-area-result',
  TEXT_SPECIALITY = 'text-speciality',
  TEXT_SPECIALITY_RESULT = 'text-speciality-result',
  TEXT_TOTAL = 'text-total',
  TEXT_WEIGHT = 'text-weight',
  TOAST_NOTIFICATION_STEP_SUGGESTION_WAITING_LIST = 'toast-notification-step-suggestion-waiting-list',
  TOAST_NOTIFICATION_WAITING_LIST = 'toast-notification-waiting-list',
  WEIGHT_FIELD = 'weight-field',
  WEIGHT_FIELD_RESULT = 'weight-field-result',
  WEIGHT_INPUT = 'weight-input',
  WIZARD_APPOINTMENTS = 'wizard-appointments',
  WIZARD_STEP_ADDITIONAL_INFORMATION = 'wizard-step-additional-information',
  WIZARD_STEP_CONSULTATION = 'wizard-step-consultation',
  WIZARD_STEP_DATE = 'wizard-step-date',
  WIZARD_STEP_EXAMS = 'wizard-step-exams',
  WIZARD_STEP_INSURANCE = 'wizard-step-insurance',
  WIZARD_STEP_LOCATION = 'wizard-step-location',
  WIZARD_STEP_QUIZ = 'wizard-step-quiz',
  WIZARD_STEP_SCHEDULE_TYPE = 'wizard-step-schedule-type',
  WIZARD_STEP_SUGGESTION = 'wizard-step-suggestion',
}
export { AppointmentsAliases };
